export class AvtManufacturerFitmentTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button[aria-controls]');
    this.details = this.button
      ? document.getElementById(this.button.getAttribute('aria-controls'))
      : null;

    if (!this.button || !this.details) return;

    this.button.addEventListener('click', this.handleClick);
    this.details.addEventListener('toggle', this.syncExpandedState);
    this.syncExpandedState();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.details?.removeEventListener('toggle', this.syncExpandedState);
  }

  handleClick = () => {
    if (!this.details) return;

    this.details.open = true;
    this.syncExpandedState();
    this.details.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
    this.details.querySelector('summary')?.focus({ preventScroll: true });
  };

  syncExpandedState = () => {
    this.button?.setAttribute('aria-expanded', String(Boolean(this.details?.open)));
  };
}

if (!customElements.get('avt-manufacturer-fitment-trigger')) {
  customElements.define('avt-manufacturer-fitment-trigger', AvtManufacturerFitmentTrigger);
}
